module.exports = "https://cdn.redage.net/src/views/player/help/images/clot2.jpg";